/* JBD 12 Oct 2026 - inner pages. Big Post (shipping quotes app) prints "Could not load widget." on every
   product page while the app is not set up. Hide the widget only while it shows that error. */
(function () {
  function check() {
    var w = document.getElementById('bigpost-widget');
    if (w && /could not load widget/i.test(w.textContent || '')) w.classList.add('jbd-bp-failed');
  }
  if (!document.querySelector('product-form, .product-form')) return;
  check();
  var tries = 0, t = setInterval(function () { check(); if (++tries > 20) clearInterval(t); }, 500);
})();
